import React from "react";
import ReactApexChart from "react-apexcharts";
import { Icon } from "@iconify/react";
import { formatNumber } from "../../utils/dashboardFormat";

const CampaignAnaLytics = ({ charts, legacy }) => {
    const perf = charts?.campaignPerformance;
    const labels = perf?.labels || ["COMPLETED", "QUEUE", "FAILED"];
    const colors = perf?.colors || ["#2563EB", "#F59E0B", "#EF4444"];
    const series = Array.isArray(perf?.data)
        ? perf.data.map((n) => Number(n) || 0)
        : Array.isArray(legacy)
          ? legacy.map((n) => Number(n) || 0)
          : [0, 0, 0];

    const total = series.reduce((a, b) => a + b, 0);
    const hasData = total > 0;

    const options = {
        labels,
        colors,
        legend: { show: false },
        dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(0)}%`,
        },
        stroke: { width: 0 },
        plotOptions: {
            pie: {
                donut: {
                    size: "62%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Total",
                            formatter: () => formatNumber(total),
                        },
                    },
                },
            },
        },
        tooltip: {
            y: {
                formatter: (val) => formatNumber(val),
            },
        },
    };

    return (
        <div className="col-xxl-4 col-lg-4 col-md-12">
            <div className="card h-100 radius-8 border-0 overflow-hidden">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-2">
                        <div>
                            <h6 className="mb-1 text-lg">Campaign Performance</h6>
                            <p className="mb-0 text-secondary-light text-sm">
                                Distribution by status
                            </p>
                        </div>
                    </div>

                    {hasData ? (
                        <>
                            <ReactApexChart
                                options={options}
                                series={series}
                                type="donut"
                                height={250}
                            />
                            <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
                                {labels.map((label, i) => (
                                    <li key={label} className="d-flex align-items-center gap-2">
                                        <span
                                            className="w-12-px h-12-px radius-2"
                                            style={{ background: colors[i] }}
                                        />
                                        <span className="text-secondary-light text-sm">
                                            {label}:{" "}
                                            <span className="text-primary-light fw-semibold">
                                                {formatNumber(series[i] || 0)}
                                            </span>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : (
                        <div className="dash-empty">
                            <Icon icon="mdi:chart-donut" />
                            <strong>No campaigns yet</strong>
                            <span className="text-sm">Create a campaign to see performance here</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CampaignAnaLytics;
